import { SpecialFilter } from '../../components/evidence/history-evidence/overrides/table-searchbar';
import { SpecialFilterTextCell } from '../../components/evidence/history-evidence/special-filter-cells/special-filter-text-cell';
import { useSpecialFilterSelectCellFactory } from '../../components/evidence/history-evidence/special-filter-cells/special-filter-select-cell';
import { useEmpowermentStates } from './empowerment-requests-api';
import { ApiFilterOperation } from '@eas/common-web';

export function useSpecialFilters(): SpecialFilter[] {
  return [
    {
      label: 'Stav',
      filterkey: 'state.id',
      operation: ApiFilterOperation.EQ,
      FilterCell: useSpecialFilterSelectCellFactory(useEmpowermentStates),
    },
    {
      label: 'Zmocnitel - Název',
      filterkey: 'empowerer.name',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zmocnitel - IČO / UID',
      filterkey: 'empowerer.identifier',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zmocnitel - OP / pas',
      filterkey: 'empowerer.identityDocumentsConcatenated',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zmocněnec - Název',
      filterkey: 'agent.name',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zmocněnec - IČO / UID',
      filterkey: 'agent.identifier',
      FilterCell: SpecialFilterTextCell,
    },
    {
      label: 'Zmocněnec - OP / pas',
      filterkey: 'agent.identityDocumentsConcatenated',
      FilterCell: SpecialFilterTextCell,
    },
  ];
}
